/*!
 * Coming Soon badge override
 * When a product is tagged 'coming soon' and unavailable, swap "Sold out"
 * labels/buttons to "Coming Soon" — on the product page (body-level flag),
 * on collection/grid product cards (per-card flag), and in the quick-shop
 * panel (per-panel flag).
 *
 * Swapped badges also get a 'label--coming_soon' class so they can be styled
 * independently of genuine Sold Out badges (dark blue, white text). The style
 * is injected here rather than in a theme stylesheet to keep this override
 * self-contained in one file.
 *
 * Note: the quick-shop button and stock note are handled server-side in
 * snippets/quick-shop.liquid, so the correct text is present on first paint.
 * The pass below exists to re-apply it after a client-side variant change,
 * which rewrites those from theme.localize() strings.
 */
(function () {
  var STYLE_ID = 'coming-soon-badge-style';
  var BADGE_BG = '#0C4A6E';
  var BADGE_TEXT = '#FFFFFF';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.label.label--coming_soon{background-color:' + BADGE_BG + ';}' +
      '.label.label--coming_soon .label__text{color:' + BADGE_TEXT + ';}';
    document.head.appendChild(style);
  }

  function getLabel() {
    var label = (window.theme && typeof window.theme.localize === 'function')
      ? window.theme.localize('COMING_SOON')
      : '';
    return label || 'Coming Soon';
  }

  function swapAddButtonText(scope, label) {
    var addTextEls = scope.querySelectorAll(
      '.js-product-add-text, [name="add"] staged-action-text'
    );
    addTextEls.forEach(function (el) {
      var buttonsContainer = el.closest('.js-product-buttons');
      var isDisabled = buttonsContainer
        ? buttonsContainer.classList.contains('is-disabled')
        : el.closest('[disabled]') !== null;
      if (isDisabled) {
        el.textContent = label;
      }
    });
  }

  function swapBadgeText(scope, label) {
    var badgeTextEls = scope.querySelectorAll(
      '[data-label="sold_out"] .label__text, .label--sold_out .label__text'
    );
    badgeTextEls.forEach(function (el) {
      el.textContent = label;
      var badge = el.closest('.label');
      if (badge) {
        badge.classList.add('label--coming_soon');
      }
    });
  }

  function swapCardQuickButton(scope, label) {
    var quickButtons = scope.querySelectorAll('.product-card-btn__btn[disabled]');
    quickButtons.forEach(function (el) {
      el.textContent = label;
    });
  }

  function swapStockNote(scope, label) {
    var stockNotes = scope.querySelectorAll('.stock-note--sold .stock-note__text');
    stockNotes.forEach(function (el) {
      el.textContent = label;
    });
  }

  function applyComingSoonLabel() {
    var label = getLabel();
    ensureStyles();

    // Product detail page: single body-level flag
    if (document.body.dataset.comingSoon === 'true') {
      swapAddButtonText(document, label);
      swapBadgeText(document, label);
      swapStockNote(document, label);
    }

    // Collection / grid pages: one flag per product-card
    document.querySelectorAll('product-card[data-coming-soon="true"]').forEach(function (card) {
      swapBadgeText(card, label);
      swapCardQuickButton(card, label);
    });

    // Quick-shop panels: one flag per quick-shop element
    document.querySelectorAll('quick-shop[data-coming-soon="true"]').forEach(function (panel) {
      swapAddButtonText(panel, label);
      swapBadgeText(panel, label);
      swapStockNote(panel, label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyComingSoonLabel);
  } else {
    applyComingSoonLabel();
  }

  document.addEventListener('variant:changed', applyComingSoonLabel);
})();
